var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!!_vm.value)?_c('div',[_c('form-row',{attrs:{"is-text":"","label":"Created"}},[_c('div',[_vm._v(_vm._s(_vm._f("date")(_vm.value.created)))]),(_vm.value.createdby_user)?_c('div',[_vm._v("By "+_vm._s(_vm.value.createdby_user.name))]):_vm._e()]),(!_vm.noDivider)?_c('form-divider'):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }